import * as React from 'react';
import { debounce } from '../models/UiUtils';

const defaultDelay = 500;

export function useDebounceValue<T>(value: T, delay: number = defaultDelay): T {
	const [debouncedValue, setDebouncedValue] = React.useState<T>(value);
	React.useEffect(() => {
		const timer = setTimeout(() => setDebouncedValue(value), delay);
		return () => {
			clearTimeout(timer);
		};
	}, [value, delay]);
	return debouncedValue;
}

export function useDebounceCallback<T extends unknown[]>(
	callback: (...args: T) => unknown,
	delay: number = defaultDelay
) {
	const callbackRef = React.useRef(callback);

	React.useLayoutEffect(() => {
		callbackRef.current = callback;
	});

	return React.useMemo(() => debounce((...args: T) => callbackRef.current(...args), delay), [delay]);
}
